import React from 'react';

var _path;

var SvgRepeatOrderMajor = function SvgRepeatOrderMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8a.992.992 0 0 1 .294-.707l2.999-3a1 1 0 1 1 1.414 1.414L9.414 7H15.5a2.5 2.5 0 0 0 0-5 1 1 0 1 1 0-2C17.981 0 20 2.018 20 4.5 20 6.981 17.981 9 15.5 9H9.414l1.293 1.293A.999.999 0 0 1 10 12.002a.997.997 0 0 1-.706-.294l-3-3a.99.99 0 0 1-.217-.326A.992.992 0 0 1 6 8zM3 3v11h3.5c.775 0 1.388.662 1.926 1.244l.11.12a2 2 0 0 0 2.927-.001l.11-.119h.001C12.112 14.662 12.725 14 13.5 14H17v-2a1 1 0 1 1 2 0v5.5a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1H7a1 1 0 0 1 0 2H3z"
  })));
};

export { SvgRepeatOrderMajor as S };
